import { render } from "./WallpaperLoader.vue?vue&type=template&id=aa5ba6d2"
import script from "./WallpaperLoader.vue?vue&type=script&lang=js"
export * from "./WallpaperLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__